import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import { grayScale, mBody1, mBody2, wBody1 } from "@teamsparta/design-system";

export const DesktopCarouselContainer = styled.div`
  display: none;
  ${DESKTOP} {
    display: grid;
    grid: 1fr/ 1fr 1fr 1fr;
    gap: 20px;
    width: 1152px;
  }
  @media (max-width: 1152px) {
    margin-top: 40px;
    width: 950px;
    gap: 50px 20px;
  }
`;

export const MobileCarouselContainer = styled.div`
  height: 328px;
  display: flex;
  gap: 30px;
  overflow-x: scroll;
  margin-top: 40px;
  transform-style: preserve-3d;
  scroll-snap-type: x mandatory;
  transition: left 1s;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  ${DESKTOP} {
    display: none;
  }
`;

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 300px;
  height: 300px;
  padding: 30px;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 8px 24px rgba(129, 137, 143, 0.12);
  scroll-snap-align: center;
  ${DESKTOP} {
    width: 370px;
    height: 341px;
    padding: 32px;
  }
`;

export const Ment = styled.p`
  width: 240px;
  margin-top: 18px;
  ${mBody1}
  font-size: 16px;
  font-weight: 500;
  color: ${grayScale.gray90};
  ${DESKTOP} {
    width: 306px;
    ${wBody1}
    font-size: 18px;
    font-weight: 500;
    color: ${grayScale.gray90};
    margin-top: 26px;
  }
`;

export const SeniorInfo = styled.section`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
`;

export const SeniorName = styled.strong`
  ${mBody1}
  color: ${grayScale.gray90};
`;

export const VerticalLine = styled.div`
  height: 14px;
  border-right: 2px solid ${grayScale.gray40};
`;

export const SeniorRole = styled.small`
  ${mBody2}
  font-weight: 500;
  color: ${grayScale.gray80};
`;

export const LogoWrapper = styled.div<{ logoId: number }>`
  position: relative;
  width: ${({ logoId }) => (logoId === 1 ? "134px" : "120px")};
  height: ${({ logoId }) => (logoId === 1 ? "35px" : "26px")};
`;
